import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Capabilities } from './pages/Capabilities';
import { LegacyPage } from './pages/LegacyPage';
import { Locations } from './pages/Locations';
import { EntityData } from './pages/EntityData';
import { Contact } from './pages/Contact';
import { ComplyPlus } from './pages/ComplyPlus';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { SecurityDisclaimer } from './pages/SecurityDisclaimer';
import { AccessibilityWidget } from './components/AccessibilityWidget';
import { ScrollToTop } from './components/ScrollToTop';
function AnimatedRoutes() {
  const location = useLocation();
  return <AnimatePresence mode="wait" initial={false} data-id="element-0">
      <Routes location={location} key={location.pathname} data-id="element-1">
        <Route path="/" element={<Home data-id="element-3" />} data-id="element-2" />
        <Route path="/capabilities" element={<Capabilities data-id="element-5" />} data-id="element-4" />
        <Route path="/legacy" element={<LegacyPage data-id="element-7" />} data-id="element-6" />
        <Route path="/locations" element={<Locations data-id="element-9" />} data-id="element-8" />
        <Route path="/entity-data" element={<EntityData data-id="element-11" />} data-id="element-10" />
        <Route path="/contact" element={<Contact data-id="element-13" />} data-id="element-12" />
        <Route path="/comply-plus" element={<ComplyPlus data-id="element-15" />} data-id="element-14" />
        <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-17" />} data-id="element-16" />
        <Route path="/security-disclaimer" element={<SecurityDisclaimer data-id="element-19" />} data-id="element-18" />
      </Routes>
    </AnimatePresence>;
}
export function App() {
  return <BrowserRouter data-id="element-20">
      <ScrollToTop data-id="element-21" />
      <div className="min-h-screen bg-white font-sans text-tech-slate selection:bg-muted-gold selection:text-white flex flex-col" data-id="element-22">
        <AccessibilityWidget data-id="element-23" />
        <Header data-id="element-24" />
        <main className="flex-grow" data-id="element-25">
          <AnimatedRoutes data-id="element-26" />
        </main>
        <Footer data-id="element-27" />
      </div>
    </BrowserRouter>;
}